// Stable, pleasant accent colors derived from an entity id.
//
// Used by the category cards and the analytics charts so a given category
// keeps the same color everywhere (consistency without storing a color).

export const ACCENTS = [
  '#4F46E5', // indigo
  '#0EA5E9', // sky
  '#16A34A', // green
  '#D97706', // amber
  '#DC2626', // red
  '#9333EA', // purple
  '#0D9488', // teal
  '#DB2777', // pink
];

/** A stable accent for an entity id (handles negative/out-of-range ids safely). */
export const accentForId = (id: number): string =>
  ACCENTS[((id % ACCENTS.length) + ACCENTS.length) % ACCENTS.length];

/** Neutral grays for buckets without a "real" entity. */
export const UNCATEGORIZED_COLOR = '#94A3B8'; // slate-400 — no category / no linked task
export const OTHER_COLOR = '#64748B'; // slate-500 — rolled-up long tail in analytics
